<template>
    <div class="table-functions">
        <div class="top-bar">
            <div class="top-bar--left">
                    <span v-if="isFilesSelect">
                        <b-form-select plain v-model="massActionSelected" :options="massActionList" class="sel sel--small"></b-form-select>
                        <b-button variant="-orange" size="-small">Apply</b-button>
                    </span>
            </div>
            <div class="top-bar--right">
               <b-form-input placeholder="Search" v-model="filesSearch" @input="$emit('search', filesSearch)" class="inp inp--combo inp--small"></b-form-input>
               <b-button size="-small" variant="-combo btn--primary" class="btn--small"><i class="icon icon--search"></i></b-button></div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
  export default {
    name: 'tableFunctions',
    data() {
      return {
        filesSearch: null,
        massActionSelected: 'print',
        massActionList: [
          { value: 'print', text: 'Print files' },
          { value: 'move', text: 'Move to project' },
          { value: 'copy', text: 'Copy to project' },
          { value: 'del', text: 'Delete' },
        ]

      }
    },
    computed: {
        ...mapGetters(['isFilesSelect'])
    }
  }
</script>

<style lang="scss">
    .table-functions {
        select {
            margin-left: 8px;
        }
    }
</style>
